import { render } from "./editDetails.vue?vue&type=template&id=a1d3c1f2&scoped=true"
import script from "./editDetails.vue?vue&type=script&lang=js"
export * from "./editDetails.vue?vue&type=script&lang=js"

import "./editDetails.vue?vue&type=style&index=0&id=a1d3c1f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d3c1f2"]])

export default __exports__